export class SessionEndedError extends Error {
  constructor(message = 'Session ended: no refresh token available') {
    super(message);
    this.name = 'SessionEndedError';
  }
}
